import { atom, selector } from 'recoil';
import localforage from 'localforage';
import { getCustomerId, getMapSettings, getUserId } from '../../../../Services/UserService';
import { IUserMapSettings } from '../../types';
import localForageEffect from '../../../../store/recoil/effects/localForageEffect';
import Config from '../../../../../config';

export const mapInfoWindowMapSettingsAtom = atom<IUserMapSettings>({
  key: 'map_info_window_mapSettings',
  default: {
    ...getMapSettings(),
    customerId: getCustomerId(),
    id: getUserId(),
  },
});

export const mapTypeSettingsSelector = selector<'hybrid' | 'roadmap'>({
  key: 'mapTypeSettings',
  get: ({ get }) => {
    const mapSettings = get(mapInfoWindowMapSettingsAtom);
    if (mapSettings) {
      return mapSettings.value.mapType;
    }
    return getMapSettings().value.mapType;
  },
});

export const mapInfoWindowAlarmsAtom = atom<boolean>({
  key: 'map_info_window_alarms',
  default: getMapSettings().value.alarms,
});
export const mapInfoWindowEventsAtom = atom<boolean>({
  key: 'map_info_window_events',
  default: getMapSettings().value.events.enabled,
});
export const mapInfoWindowDriverNameAtom = atom<boolean>({
  key: 'map_info_window_driver_name',
  default: getMapSettings().value.driverName,
});

export const mapInfoWindowBluecoinNameAtom = atom<boolean>({
  key: 'map_info_window_bluecoin_name',
  default: getMapSettings().value.bluecoinName,
});

export const mapInfoWindowIdentificationAtom = atom<boolean>({
  key: 'map_info_window_identification',
  default: getMapSettings().value.identification,
});
export const mapInfoWindowLicenceNumberAtom = atom<boolean>({
  key: 'map_info_window_licence_number',
  default: getMapSettings().value.licenceNumber,
});
export const mapInfoWindowVehicleNameAtom = atom<boolean>({
  key: 'map_info_window_vehicle_name',
  default: getMapSettings().value.vehicleName,
});
export const mapInfoWindowDoorsAtom = atom<boolean>({
  key: 'map_info_window_doors',
  default: getMapSettings().value.events.doors,
});
export const mapInfoWindowAdditionalAtom = atom<boolean>({
  key: 'map_info_window_additional',
  default: getMapSettings().value.events.additional,
});
export const mapInfoWindowBluecoinsAtom = atom<boolean>({
  key: 'map_info_window_bluecoins',
  default: getMapSettings().value.events.bluecoins,
});

export const getChristmasIconsFromIndexedDb = async (): Promise<boolean> => {
  const christmasIcons = await localforage.getItem<boolean>('christmasIcons');
  if (Config.festivities.christmas.enabled === false) {
    return false;
  }
  if (christmasIcons === null) {
    return true;
  }
  if (christmasIcons === true) {
    return true;
  }
  return false;
};

export const mapInfoWindowChristmasIconsAtom = atom<boolean>({
  key: 'map_info_window_christmas_icons',
  default: getChristmasIconsFromIndexedDb(),
  effects: [localForageEffect('christmasIcons')],
});
